import { useEffect, useState } from 'react';

import { useDispatch } from 'react-redux';

import { useParams } from 'react-router';

import { Box, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Grid, Paper, Tab, Tabs } from '@mui/material';

import { TabProps } from '../../../helpers/TabPanel';

import { openSnackbar } from '../../../store/slices/SnackbarSlice';

import { DialogActionsStyle, DialogContentStyle } from '../../../styles/DialogStyle';

import { Layout } from '../../../components/Layout'
import { BoxProcesoTerminado } from '../../../components/BoxProcesoTerminado';
import { BoxProcesoCancelado } from '../../../components/BoxProcesoCancelado';
import { BoxHeaderInformacion } from '../../../components/BoxHeaderInformacion';
import { BoxProcesoNoEncontrado } from '../../../components/BoxProcesoNoEncontrado';
import { BoxInformacionExpediente } from '../../../components/BoxInformacionExpediente';
import { CircularProgressIndicator } from '../../../components/CircularProgressIndicator';

import { ActualizarEstatus, DetalleCertificacion } from '../../../connections/tribunal/CertificacionConnection';

import { CertificacionProps, defaultCertificacion } from '../../../interfaces/tribunal/CertificacionInteface';

export const VisualizarCertificacionPage = () => {

    const { Id } = useParams();

    const dispatch = useDispatch();

    const [value, setValue] = useState( 0 );

    const [loading, setLoading] = useState( true );
    const [loadingFinalizar, setLoadingFinalizar] = useState( false );

    const [certificacion, setCertificacion] = useState<CertificacionProps>( defaultCertificacion );
    
    const [openConfirmacion, setOpenConfirmacion] = useState( false );
    
    const [procesoTerminado, setProcesoTerminado] = useState( false );
    const [procesoCancelado, setProcesoCancelado] = useState( false );
    const [procesoNoEncontrado, setProcesoNoEncontrado] = useState( false );
    const [mensajeFinalizacion, setMensajeFinalizacion] = useState( '' );
    const [mensajeAsignacion, setMensajeAsignacion] = useState( '' );

    const handleChange = (_: React.SyntheticEvent, newValue: number) => setValue( newValue );

    const handleFinalizar = async () => {
        
        setLoadingFinalizar( true );

        await ActualizarEstatus({ idCertificacion: Id ?? '', idEstatus: 3 }).then( resp => {

            setTimeout(() => {

                const { success, message } = resp;

                if ( success ) {

                    setMensajeFinalizacion('No se tienen actividades pendientes para este trámite');
                    setProcesoTerminado( true );
                    setLoadingFinalizar( false );

                }
                else {

                    dispatch( openSnackbar({ message, variant: 'error' }) );
                    setLoadingFinalizar( false );

                }

            }, 700);

        });

    }

    useEffect(() => {

        setLoading( true );

        async function Obtener() {

            await DetalleCertificacion( Id ?? '' ).then( resp => {

                setTimeout(() => {

                    const { success } = resp;

                    if ( success ) {

                        setCertificacion( resp );

                        if ( resp.idEstatus === 3 ) {
                            setMensajeFinalizacion('No se tienen actividades pendientes para este trámite');
                            setProcesoTerminado( true );
                            setLoading( false );
                        }
                        else if ( resp.idEstatus === 4 ) {
                            setProcesoCancelado( true );
                            setLoading( false );
                        }
                        else if ( !resp.usuarioActualAsignacion ) {
                            setMensajeAsignacion(`La siguiente actividad se asignó a: ${ resp.usuarioAsignacion }`);
                            setProcesoTerminado( true );
                            setLoading( false );
                        }
                        else if ( resp.usuarioActualAsignacion && resp.idEstatus !== 53 ) {
                            setMensajeAsignacion('La siguiente actividad se encuentra en tu bandeja');
                            setProcesoTerminado( true );
                            setLoading( false );
                        }
                        else if ( resp.usuarioActualAsignacion && resp.idEstatus === 53 ) {
                            setLoading( false );
                        }

                    }
                    else {

                        setProcesoNoEncontrado( true );
                        setLoading( false );

                    }

                }, 700);

            });

        }

        if( Id ){
            Obtener();
        }

    }, [ Id ])

    return (

        <Layout breadcrumbs={ [{ text: 'Tribunal' }, { text: 'Certificación' }, { text: 'Visualizar certificación' }] } backgroundPaper={ ( procesoTerminado || procesoCancelado || procesoNoEncontrado ) }>

            {                
                loading
                ?
                    <Box component={ Paper } height={ '70vh' } textAlign={ 'center' } alignContent={ 'center' } alignItems={ 'center' }>
                        <CircularProgressIndicator />
                    </Box>
                :

                    ( procesoTerminado || procesoCancelado || procesoNoEncontrado )
                    ?
                        procesoNoEncontrado
                        ?
                            <BoxProcesoNoEncontrado />
                        :
                            procesoCancelado
                            ?
                                <BoxProcesoCancelado />
                            :
                                <BoxProcesoTerminado message={ mensajeFinalizacion } messageAssing={ mensajeAsignacion } processEnd={ certificacion.idEstatus === 3 } />
                        :
                            <>

                                <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>

                                    <Tabs value={ value } onChange={ handleChange } aria-label='basic tabs example' variant='scrollable' scrollButtons='auto'>
                                        <Tab label='Certificación' {...TabProps(0)} />
                                        <Tab label='Información del expediente' {...TabProps(1)} />
                                    </Tabs>

                                </Box>

                                <Box sx={{ display: value === 0 ? 'block' : 'none' }}>

                                    <Box p={ 4 } component={ Paper }>

                                        <BoxHeaderInformacion 
                                            numeroSeguimiento={ `GEC-${ certificacion.idCertificacion ?? '' }` } 
                                            fecha={ certificacion.fecha ?? new Date() } 
                                            juez={ certificacion.expediente.juez ?? '' } 
                                        />

                                        <Grid container spacing={ 3 } mt={ 3 }>

                                            <Grid size={{ md: 12, xs: 12 }}>

                                                <iframe
                                                    title='iframe-documento'
                                                    style={{ width: '100%', height: '80vh', borderRadius: 8 }}
                                                    src={ certificacion.documento }
                                                />

                                            </Grid>

                                            <Grid size={{ xs: 12, md: 12 }} sx={{ mt: 3 }}>

                                                <Grid container spacing={ 3 }>

                                                    <Grid size={{ md: 4, xs: 12 }} sx={{ textAlign: 'left' }}> </Grid>

                                                    <Grid size={{ md: 4, xs: 12 }} style={{ textAlign: 'center' }}>
                                                        <Button
                                                            fullWidth
                                                            color='primary'
                                                            variant='contained'
                                                            onClick={ () => setOpenConfirmacion( true ) }
                                                        >
                                                            Finalizar
                                                        </Button>
                                                    </Grid>

                                                    <Grid size={{ md: 4, xs: 12 }} sx={{ textAlign: 'right' }}> </Grid>

                                                </Grid>

                                            </Grid>

                                        </Grid>

                                    </Box>

                                </Box>

                                <Box sx={{ display: value === 1 ? 'block' : 'none' }}>

                                    <BoxInformacionExpediente expediente={ certificacion.expediente } />

                                </Box>

                                <Dialog
                                    fullWidth
                                    maxWidth='xs'
                                    open={ openConfirmacion }
                                    onClose={ () => { } }
                                >

                                    <DialogTitle>
                                        Confirmación
                                    </DialogTitle>

                                    <DialogContent sx={ DialogContentStyle }>

                                        <DialogContentText>
                                            ¿Desea finalizar la visualización de la certificación?
                                        </DialogContentText>

                                    </DialogContent>

                                    <DialogActions sx={ DialogActionsStyle }>
                                        <Button color='secondary' disabled={ loadingFinalizar } onClick={ () => setOpenConfirmacion( false ) }> Cancelar </Button>
                                        <Button
                                            variant='contained'
                                            loading={ loadingFinalizar }
                                            onClick={ handleFinalizar }
                                        >
                                            Aceptar
                                        </Button>
                                    </DialogActions>
                                </Dialog>

                            </>
            }

        </Layout>
    )
}
